import { Space } from "interfaces/models/area";
import { GenerateDataType } from "interfaces/models/generateData";
import ForgeDataImporter, { ForgeDataImporterProps } from ".";

class SpaceImporter extends ForgeDataImporter<Space[]> {
  dataType = GenerateDataType.SPACE;

  constructor(props: ForgeDataImporterProps) {
    super(props);

    if (props.level) {
      this.dataType = GenerateDataType.SPACE_LEVEL;
    }
  }

  normalizeData(_data: any[]): Promise<Space[]> {
    const result: Space[] = [];
    _data.forEach((item) => {
      if (Object.keys(item).length) {
        result.push(item);
      }
    });

    return Promise.resolve(result);
  }
}

export default SpaceImporter;
